export const bwicHistoryActions = {
    STORE_BWIC_HISTORY: 'bwicHistory/STORE_BWIC_HISTORY',
    SHOW_BWIC_HISTORY: 'bwicHistory/SHOW_BWIC_HISTORY',
    MARK_HISTORY_MESSAGES_AS_READ: 'bwicHistory/MARK_HISTORY_MESSAGES_AS_READ',
    RESET: 'bwicHistory/RESET',
    LOAD_HISTORY_REQUEST_STATE: 'bwicHistory/LOAD_REQUEST_STATE'
};
